(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const headerAlways = document.querySelector(".header-always");

		if (headerAlways) {
			header.classList.add("always-show");
		}

		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		//menuLinks &&
		//	menuLinks.forEach((link) => {
		//		link.addEventListener("mouseenter", (e) => {
		//			if (link.classList.contains("list-menu--megamenu")) {
		//				link.classList.add("list-menu--megamenu-visible");
		//				if (
		//					header.classList.contains("color-background-2") &&
		//					!header.classList.contains("shopify-section-header-sticky")
		//				) {
		//					header.classList.remove("color-background-2");
		//				}

		//				menuLinks.forEach((el) => {
		//					if (el !== link) {
		//						el.classList.remove("list-menu--megamenu-visible");
		//					}
		//				});
		//			} else {
		//				menuLinks.forEach((el) => {
		//					el.classList.remove("list-menu--megamenu-visible");
		//				});
		//			}
		//		});
		//	});
		//menu &&
		//	menu.addEventListener("mouseleave", (e) => {
		//		menuLinks.forEach((link) => {
		//			link.classList.remove("list-menu--megamenu-visible");
		//		});
		//	});

		const addBackground = () => {
			if (document.querySelector(".overflow-hidden-drawer")) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-2") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-2");
					}

					if (
						header.classList.contains("section--have-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("have-background");
					}
				}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {
			if (
				document.querySelector(".overflow-hidden") ||
				document.querySelector(".overflow-hidden-drawer")
			) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("color-background-2");
					}

					if (
						header.classList.contains("section--have-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("have-background");
					}
				}
			});

			headerObserver.observe(header);
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		document.addEventListener("DOMContentLoaded", () => {
			const firstSection = document.querySelector("main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)");
			let isSectionVisible = false;
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting && !isSectionVisible) {
						isSectionVisible = true;
						header.classList.add("entering-section", "color-background-2");
					} else if (!entry.isIntersecting && isSectionVisible) {
						isSectionVisible = false;
						header.classList.remove("entering-section");
					}
				},
				{ threshold: 0.15 }
			);

			if (firstSection) {
				observer.observe(firstSection);
			}

			window.addEventListener("scroll", () => {
				if (isSectionVisible) {
					header.classList.add("entering-section", "color-background-2");
				}
			});
		});

		//const megaMenuListLinks = () => {
		//	const megaMenuLinkWithSubmenu = document.querySelector(
		//		".mega-menu__list-item--children"
		//	);
		//	const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
		//	if (megaMenuLinkWithSubmenu) {
		//		megaMenuLinks.forEach((link) => {
		//			link.classList.add("mega-menu__list-item--opacity");
		//		});
		//		megaMenuLinkWithSubmenu.classList.remove(
		//			"mega-menu__list-item--opacity"
		//		);
		//		megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
		//	}
		//	$(".mega-menu__list-item").mouseenter(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//	$(".mega-menu__list-item").focus(function (event) {
		//		if (megaMenuLinkWithSubmenu) {
		//			megaMenuLinkWithSubmenu.classList.remove(
		//				"mega-menu__list-item--visible"
		//			);
		//		}
		//		$(this).removeClass("mega-menu__list-item--opacity");
		//		$(this).siblings().addClass("mega-menu__list-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this).siblings().removeClass("mega-menu__list-item--opacity");
		//		});
		//	});
		//};

		//const megaMenuSublinks = () => {
		//	$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
		//		event
		//	) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).mouseleave(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//	$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
		//		$(this).removeClass("mega-menu__submenu-item--opacity");
		//		$(this)
		//			.parent()
		//			.siblings()
		//			.find(".mega-menu__submenu-item")
		//			.addClass("mega-menu__submenu-item--opacity");
		//		$(this).focusout(() => {
		//			$(this)
		//				.parent()
		//				.siblings()
		//				.find(".mega-menu__submenu-item")
		//				.removeClass("mega-menu__submenu-item--opacity");
		//		});
		//	});
		//};
		//megaMenuListLinks();
		//megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelectorAll(".shopify-section")[0]
				?.classList.contains("section--has-overlay") &&
			!main
				.querySelectorAll(".shopify-section")[0]
				?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-2");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-2");
			}
		}
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();

$('.header nav .list-menu--submenu:has(>a[aria-label="Curtains"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/linen-curtains/"><img src="/cdn/shop/files/nav-LinenCurtain.png"><p>Elevate Your Home</p><p>Linen Curtain</p><span>Shop Now</span></a></li>`);
$('.header nav .list-menu--submenu:has(>a[aria-label="Shades"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/roman-shade/"><img src="/cdn/shop/files/nav-Roman.png" style="min-height: 21.6rem;"><p>Bath in Layered Light</p><p>Roman Shades</p><span>Shop Now</span></a><a class="navImg" target="_blank" href="${window.Shopify.routes.root}products/mia-jute-woven-shade-sand/"><img src="/cdn/shop/files/nav-Mia.png"><p>Refined by Nature</p><p>Woven Shades</p><span>Shop Now</span></a></li>`);
$('.header nav .list-menu--submenu:has(>a[aria-label="Outdoor"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/outdoor-woven-shade/"><img src="/cdn/shop/files/nav-OutdoorWovenShades.png"><p>Bring Texture Outside</p><p>Outdoor Woven Shades</p><span>Shop Now</span></a><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/uv-shield/"><img src="/cdn/shop/files/nav-ShadesSail.png"><p>Get UV Protection</p><p>Custom Shade Sail</p><span>Shop Now</span></a></li>`);
$('.header nav .list-menu--submenu:has(>a[aria-label="Accessories"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/rods/"><img src="/cdn/shop/files/nav-Rods.png"><p>Add Finishing Touches</p><p>Custom Curtain Rods</p><span>Shop Now</span></a><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/holdbacks/"><img src="/cdn/shop/files/nav-Holdbacks.png"><p>Small Detail, Big Impact</p><p>Curtain Holdbacks</p><span>Shop Now</span></a></li>`);
$('.header nav .list-menu--submenu:has(>a[aria-label="Swatches"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/curtain-swatches/"><img src="/cdn/shop/files/nav-CurtainSwatches.png"><p>See. Touch. Decide.</p><p>Curtain Swatches</p><span>Shop Now</span></a><a class="navImg" target="_blank" href="${window.Shopify.routes.root}collections/shade-swatches/"><img src="/cdn/shop/files/nav-ShadeSwatches.png"><p>Find Your Woven Match</p><p>Woven Shade Swatches</p><span>Shop Now</span></a></li>`);
$('.header nav .list-menu--submenu:has(>a[aria-label="Resources"]) ul div').append(`<li><a class="navImg" target="_blank" href="${window.Shopify.routes.root}pages/curtain-measurement"><img src="https://cdn.shopify.com/s/files/1/0755/8797/7466/files/page_homepage_collList1.jpg?v=1757489238&width=253"><p>Soft drape, lasting style</p><p>MEASURE FOR CURTAINS</p><span>USE MEASURING TOOL</span></a><a class="navImg" target="_blank" href="${window.Shopify.routes.root}pages/shade-measurement"><img src="https://cdn.shopify.com/s/files/1/0755/8797/7466/files/wuji_BLACK5_copy.jpg?v=1756196300&width=253"><p>Subtle control, modern look</p><p>MEASURE FOR SHADES</p><span>USE MEASURING TOOL</span></a></li>`);